export const getRoleName = (): string => {
    switch (window.location.host) {
        case 'localhost:44388':
        case 'snellman-anelma3-dev.mtech.fi':
        case 'snellman-anelma3-test.mtech.fi':
        case 'snellman-anelma3-demo.mtech.fi':
        case 'snellman-anelma3-production-demo.mtech.fi':
        case 'anelma3.snellman.fi':
            return 'Snellman Anelma - Feedback';
        default:
            return 'SNE Administrator';
    }
};

/** Get 'main user role' name that can be different in every environment. */
export const getMainUserRoleName = () => {
    switch (window.location.host) {
        case 'localhost:44388':
        case 'snellman-anelma3-dev.mtech.fi':
        case 'snellman-anelma3-test.mtech.fi':
            return 'Head user - Farm';
        case 'snellman-anelma3-demo.mtech.fi':
            return 'Farms main user';
        case 'anelma3.snellman.fi':
        case 'snellman-anelma3.mtech.fi':
        case 'snellman-anelma3-production-demo.mtech.fi':
            return 'Main user - Farm';
        default:
            return 'Main user - Farm';
    }
};
